import React, { useEffect, useRef, useState } from 'react';
import Auth from '../../Auth';

export default ({ word, open, onOpenChange }) => {
  const [feedback, setFeedback] = useState("");
  const [sent, setSent] = useState(false);
  const triggerRef = useRef(null);
  const textareaRef = useRef(null);
  const wasOpenRef = useRef(false);

  const submit = e => {
    e.preventDefault();
    Auth.fetchWithIdToken("/api/slackFeedback", { title: "Related Words Feedback", message: feedback + `\n\nFor word: ${word}` });
    setSent(true);
    onOpenChange(false);
  };

  const closeForm = () => {
    onOpenChange(false);
  };

  useEffect(() => {
    if (open) {
      wasOpenRef.current = true;
      textareaRef.current?.focus();
    } else if (wasOpenRef.current) {
      wasOpenRef.current = false;
      triggerRef.current?.focus();
    }
  }, [open]);

  return (
    <div className="feedback" onClick={e => e.stopPropagation()}>

      {!open &&
        <button
          ref={triggerRef}
          type="button"
          className="closed"
          onClick={e => {
            onOpenChange(true);
            e.stopPropagation();
          }}
        >
          {sent &&
            <>Sent! Give more?</>
          }
          {!sent &&
            <>Feedback</>
          }
        </button>
      }
      {open &&
        <form
          className="open"
          aria-label="Related words feedback"
          onSubmit={submit}
          onKeyDown={e => {
            if (e.key === "Escape") {
              e.preventDefault();
              e.stopPropagation();
              closeForm();
            }
          }}
        >
          <p>How can we improve the results for this word?</p>

          <textarea
            ref={textareaRef}
            aria-label="Feedback"
            value={feedback}
            onChange={e => {
              setFeedback(e.target.value);
            }}
          />

          <div className="feedback-actions">
            <button type="submit">Submit</button>
            <button type="button" onClick={closeForm}>Cancel</button>
          </div>
        </form>
      }
    </div>
  );
};
